import React from 'react';

const CTASection = () => {
  return (
    <section className="py-4 bg-white animate-on-scroll">
      <div className="container mx-auto mb-20">
        <div className="bg-gray-900 text-white rounded-2xl px-6 py-10 md:px-10 md:py-12 lg:px-14 lg:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="space-y-2">
            <h2 className="text-2xl md:text-3xl font-bold">Prêt à livrer avec OuiGoo ?</h2>
            <p className="text-gray-300 text-sm md:text-base">On active votre compte, on connecte vos boutiques et on lance vos livraisons.</p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="https://business.ouigoo.co"
              className="inline-flex items-center justify-center px-5 py-3 bg-primary-custom  text-white rounded-lg font-semibold transition-colors hover:bg-primary-custom-dark transition-all"
            >
              Demarrer maintenant
            </a>
            <a
              href="/get-quote"
              className="inline-flex items-center justify-center px-5 py-3 border border-gray-500 text-white rounded-lg font-semibold hover:bg-white hover:text-black transition-colors"
            >
              Calculer un tarif
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
